import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Header from './header';
import Content from './content';

class Layout extends React.PureComponent {
    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        return (
            <div className={styles.layout}>
                <Header />
                <Content />
            </div>
        );
    }
}

export default errorBoundary(Layout);
